<template>
  <div class="goods_add">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div class="mt-20">
        <el-card>
          <el-form-item label="用户名">
            <span>{{ ruleForm.name }}</span>
          </el-form-item>
          <el-form-item label="等级" prop="level">
            <el-select
              v-model="ruleForm.level"
              placeholder="请选择等级"
              :value-key="ruleForm.level"
            >
              <el-option
                :label="item"
                :value="item"
                v-for="(item, index) in result.data"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="余额">
            <span v-if="wallet.data">{{ wallet.data.money }}</span>
            <el-button type="primary" @click="recharge()" size="mini">充值</el-button>
          </el-form-item>
            <el-form-item label="设置">

              <el-button @click="set_current_id"> 暂无上级 </el-button>
            </el-form-item>
          <el-form-item label="当前上级">
            <span v-if="current_id == 0"> 暂无上级 </span>
            <span v-else> {{ this.current_user }}{{ this.level }}</span>
          </el-form-item>
          <el-form-item label="用户搜索">
            <span>
              <el-autocomplete
                v-model="state_user"
                :fetch-suggestions="querySearchAsync"
                placeholder="用户搜索"
                @select="handleSelect"
              ></el-autocomplete
            ></span>
              <span>   <el-button @click="set_default_current_user" > 默认上级 </el-button></span>
          </el-form-item>

          <el-form-item label="是否启用" prop="status">
            <el-select
              v-model="ruleForm.status"
              placeholder="请选择"
              :value-key="ruleForm.status"
            >
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-button type="primary" @click="submitForm('ruleForm')" v-if="result"
            >立即编辑</el-button
          >
          <el-button @click="resetForm('ruleForm')" ref="ruleForm">重置</el-button>
        </el-card>
      </div>
    </el-form>
    <el-form
      :model="areaForm"
      :rules="rules"
      ref="areaForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div class="mt-20">
        <el-card class="box-card">
          <div class="custom-tree-container">
            <div class="block">
              <p class="demonstration">设置保护区域</p>

              <el-cascader
                :value="default_options"
                ref="cascader"
                :options="options"
                :props="props"
                clearable
                v-if="isload == true"
                @change="change"
              ></el-cascader>
            </div>
          </div>
          <div class="mt-20">
            <el-button type="primary" @click="addArea">立即设置</el-button>
          </div>
        </el-card>
      </div>
    </el-form>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>
        <el-input v-model="money" placeholder="金额"></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="recharge_confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      isload: false,
      dialogVisible: false,
      area: [],
      area_content:[],
      money: 0,
      restaurants: [],
      state_user: "",
      default_level: "",
      level: "",
      current_id: 0,
        default_current_id:"",
      current_user: "",
      default_current_user:"",

      props: {
        multiple: true,
      },

      options: [],
      default_options: [],

      id: 0,
      areaForm: {},
      ruleForm: {
        level: "",
        status: "1",
        user_id: 0,
        name: name,
      },
      rules: {
        level: [
          {
            required: true,
            message: "请选择等级",
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      result: (state) => state.agentuser.result,
      areadata: (state) => state.area.result,
      addAreaData: (state) => state.area.code,
      search_agent_user: (state) => state.search_agent_user.result,
      wallet: (state) => state.wallet.result,
    }),
  },
  methods: {
    ...mapActions({
      agentUserEditAction: "agentUserEditAction",
      getAreaDataAction: "getAreaDataAction",
      addAreaUserDataAction: "addAreaUserDataAction",
      AgentUserSearchAction: "AgentUserSearchAction",
      rechargeWalletUserDataAction: "rechargeWalletUserDataAction",
      getWalletDataAction: "getWalletDataAction",
    }),
    recharge() {
      this.dialogVisible = true;
    },
    set_default_current_user(){

        this.current_user=this.default_current_user
        this.level=this.default_level
        this.current_id=this.default_current_id
    },
    set_current_id(){
        this.current_id =0
    },
      recharge_confirm() {
          this.$confirm('充值, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.addrecharge()
          }).catch(() => {
              this.$message({
                  type: 'info',
                  message: '已取消充值'
              });
              this.dialogVisible = false;
          });
      },

    addrecharge() {
      let user_id = this.ruleForm.user_id;

      this.rechargeWalletUserDataAction({ user_id: user_id, money: this.money });
      this.dialogVisible = false;
    },
    querySearchAsync(queryString, cb) {
      this.AgentUserSearchAction({ username: queryString, type: "post" });
      this.current_id = 0;
      this.level = "";
      // this.restaurants = this.agent_user.options;

      var results = queryString
        ? this.restaurants.filter(this.createStateFilter(queryString))
        : this.restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 200 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect(item) {
      this.level = item.level;
      this.current_user = item.value;
      this.current_id = item.id;
    },
    addArea() {
      if (this.area.length == 0) {
        this.$message({
          message: "请设置地址",
          type: "warning",
        });
        return;
      }
      this.addAreaUserDataAction({
        area: JSON.stringify(this.area),
        user_id: this.ruleForm.user_id,
        "area_content":JSON.stringify(this.area_content)
      });
    },
    change(val) {
      console.log(val);
      this.area_content=[]
      let nodes=this.$refs.cascader.getCheckedNodes()
        for (let i=0;i<nodes.length; i++){
            this.area_content[i]=nodes[i]['pathLabels']
            console.log(nodes[i]['pathLabels'])
        }
        console.log(this.area_content);
      this.area = val;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          this.$message("请输入正确信息");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    saveData() {
      let status = 1;

      if (this.ruleForm.status == "禁用") {
        status = 0;
      }
      //用户等
      // alert(this.ruleForm.level);
      // alert(this.level);
      let level_data = this.result.data;
      //当前上级
      let i = level_data.indexOf(this.level);
      //当前用户等级
      let j = level_data.indexOf(this.ruleForm.level);

      if (i == -1 && j > 0) {
        this.$message({
          message: "请选择用户等级为省代",
          type: "warning",
        });
        return;
      }
      if (i >= j) {
        this.$message({
          message: "请选择正确的等级",
          type: "warning",
        });
      }

      this.agentUserEditAction({
        type: "post",

        level: this.ruleForm.level,
        status: status,
        pid: this.current_id,
        id: this.ruleForm.user_id,
      });
    },
    IterationDelateMenuChildren(arr) {
      if (arr.length > 0) {
        for (let i in arr) {
          if (arr[i].children.length) {
            this.IterationDelateMenuChildren(arr[i].children);
          } else {
            arr[i].children = undefined;
          }
        }
      }
      return arr;
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.agentUserEditAction({ type: "get", id: this.id });
  },

  watch: {
    wallet(newdata) {
      if (newdata.code == 302) {
        this.$message({
          message: "用户充值成功",
          type: "success",
        });
      }
    },
    search_agent_user(newdata, olddata) {
      if (newdata.options.length == 0) {
        this.current_user = "";
      } else {
        this.restaurants = newdata.options;
      }
      console.log("tag", newdata, olddata);
    },
    addAreaData(newdata) {
      if (newdata.code == 301) {
        this.$message({
          message: "地址设置成功",
          type: "success",
        });
        setTimeout(() => {
          this.$router.push({
            name: "agent_user_index",
          });
        }, 200);
      }
    },
    result(newdata, olddata) {
      if (newdata.code == 200) {
        this.ruleForm.name = newdata.agent_user.username;
        this.ruleForm.user_id = newdata.agent_user.id;
        this.ruleForm.level = newdata.agent_user.level;

        this.getWalletDataAction({ id: newdata.agent_user.id });
        if (newdata.agent_user.p_user) {
          this.current_id = newdata.agent_user.p_user.id;
          this.level = newdata.agent_user.p_user.level;
         this.default_level = newdata.agent_user.p_user.level;
          this.current_user = newdata.agent_user.p_user.username;
          this.default_current_user=newdata.agent_user.p_user.username;
            this.default_current_id = newdata.agent_user.p_user.id;
        }

        this.getAreaDataAction({ user_id: this.ruleForm.user_id });
        if (newdata.agent_user.status == "1") {
          this.ruleForm.status = "启用";
        }
        if (newdata.agent_user.status == "0") {
          this.ruleForm.status = "禁用";
        }
      }
      if (newdata.code == 301) {
        this.$message({
          message: "用户更新成功",
          type: "success",
        });
      }
      console.log(newdata, olddata);
    },
    areadata(newdata, olddata) {
      this.options = this.IterationDelateMenuChildren(newdata.data);
      if (newdata.area_default.length > 0) {
        this.default_options = JSON.parse(newdata.area_default);
        this.area = this.default_options;
      }

      // alert(this.default_options);
      console.log(newdata, olddata);

      this.isload = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.quill-editor {
  height: 400px;
}

.quill-editor-bottom {
  margin-bottom: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #260a0a;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.title_bg {
  background-color: #f5fffa;
  padding: 10px;
}

.el-form-item__content {
  margin-left: 30px;
}
.mt-20 {
  margin-top: 20px;
}
</style>
